import { useMemo } from 'react'

import type { LatLngExpression } from 'leaflet'

import { Offer } from '@wwt/entities/search-response'
import { getFullAddress } from '@wwt/shared/utils/address/getFullAddress.ts'

export const useOfferCardLocation = (
	offer: Offer,
	hasClickableLocation?: boolean
) => {
	const location = useMemo(() => {
		if (!offer) return ''

		return getFullAddress(offer.hotelStatic.geolocation.address)
	}, [offer])

	const coordinates: LatLngExpression | undefined = useMemo(() => {
		return hasClickableLocation
			? [
					offer.hotelStatic.geolocation.latitude,
					offer.hotelStatic.geolocation.longitude
				]
			: undefined
	}, [offer, hasClickableLocation])

	return useMemo(
		() => ({
			coordinates: coordinates,
			location,
			nonPersistingOfferId: offer.IDs.nonPersistingOfferId
		}),
		[location, coordinates, offer.IDs.nonPersistingOfferId]
	)
}
